<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="sales-order-v2"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :refreshColumns="refreshColumns"
    class="sales-order-v2"
    :headerScreenJson="getHeaderScreenJson"
    :data-model="model"
    :refreshHeaderFormProp="refreshHeaderForm"
    :searchForItem="searchForItem"
  >
    <!-- <div
      style="
        position: fixed;
        top: 0px;
        padding: 5px;
        width: 100%;
        border: 2px solid red;
        z-index: 100000;
        background-color: rgba(240, 255, 255, 1);
      "
    >
      {{ model.CustomerCode }}

      {{ model.DeliveryAddressCompanyName }} -->

    <!-- {{ productEntryLocalItems }} -->
    <!-- </div> -->
  </TransactionTemplate>
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
// import { BranchService } from "../../_services/api/sales/branch.service";
import {
  getFactorByCode,
  // getDefaultCustomerSettings,
} from "../../_store/helpers";
import { mapGetters } from "vuex";
// import { alert } from "devextreme/ui/dialog";
import { StockTransferService } from "../../_services/api/inventory/stock-transfer-service";
import { ProductService } from "../../_services/api/products/product.service";
import { CustomerDeliveryAddressService } from "../../_services/api/customers/customer-delivery-address.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { FeatureStorage } from "../../_services/storage";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { SalesOrderV2Service } from "../../_services/api/sales/sales-order-v2.service";
import validationEngine from "devextreme/ui/validation_engine";
// import { SalesOrderProductDetails } from "../../_services/api/sales/sales-order-product-details.service";
// import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import salesFormulas from "../../_helpers/formulas/sales-formulas";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import { SalesOrderNoteService } from "../../_services/api/sales/sales-order-note.service";
// eslint-disable-next-line no-unused-vars
let proceedWithCustomerClick = false;

// function isValidDate(d) {
//   return d instanceof Date && !isNaN(d);
// }

const {
  // calculateGrossProfitPcnt,
  // calculateSalesUMPriceForGP,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateSalesUMNetFXPrice,
  calculateStockUMPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMQty,
  calculateStockUMNetFXPrice,
  calculateDiscLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
  calculateSalesUMNetPriceFromSalesUMNetFXPrice,
  calculateSalesUMPriceFromSalesUMFXPrice,
  calculateCalculatedDiscPcnt,
  // calculateSalesUMNetFXPriceFromSalesUMFXPrice,
} = salesFormulas;

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG >>> ", ...arguments);
}

let productEntryBase = {
  ProductCode: undefined,
  ProductDescription: undefined,
  SalesUM: undefined,
  SalesUMQty: 0,
  SalesUMFXPrice: 0,
  DiscPcnt: 0,
  SalesUMNetFXPrice: 0,
  TaxableFXLineTotal: 0,
  Code: undefined,
  LineNo: 0,
  ID: 1,

  IsBatchProduct: "No",
  BranchCode: undefined,
  BranchDescription: undefined,
  UnitOfMeasureCode: undefined,
  Onhand: 0,
};
let deliveryAddressDataSourceItems = [];

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      refreshHeaderForm: false,
      loaded: false,
      setLoading: false,
      reload: false,
      validationSummary: [],
      serverError: {},
      refreshColumns: undefined,
      ui: {
        DateAdjustedMin: null,
        DateAdjustedMax: null,
      },

      defaultDivisionCode: undefined,
      defaultOrderTypeCode: undefined,
      defaultSalesRepCode: undefined,
      defaultBranchCode: undefined,
      factor368ExchangeRateFieldEditable: undefined,
      dataModel: {
        DateIn: new Date(),
        DateReceived: new Date(),
        // toFriendlyStatus: "N",
        Status: "N",
      },
      brokenGridValidations: [],
      // Start
      // branchDataSourceItems: [],
      // deliveryAddressDataSourceItems: [],

      model: {
        CompanyCurrency: undefined,
        Status: "N",
        CustomStatus: undefined,
        FriendlyStatus: undefined,
        Code: null,

        CustomerCode: null,
        DateIn: new Date(),
        RequiredByDate: null,
        ShipDate: null,
        OrderNo: null,

        DeliveryAddressCompanyName: "",
        DeliveryAddressCountry: "",
        DeliveryAddressPostcode: null,
        DeliveryAddressState: "",
        DeliveryAddressStreetLine1: "",
        DeliveryAddressStreetLine2: "",
        DeliveryAddressSuburb: "",
        CustomerDeliveryAddressLineNo: undefined,

        ConsignmentNo: "",
        CurrencyCode: undefined,
        ExchangeRate: 1,

        BranchCode: null,
        DivisionCode: null,
        SalesOrderTypeCode: null,
        SalesRepresentativeCode: "",

        SalesOrderDetails: [],

        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        Notes: [],
      },

      productEntryLocalItems: [],
      productDataSourceItems: [],
      enterNewLine: false,
      newLineID: undefined,
      salesUMsLocalData: [],
      searchForItem: {},
      productListItems: undefined,
      validationLineData: undefined,
      validationDataField: undefined,
      focusedCell: undefined,
      previousColumnIndex: undefined,
    };
  },

  async created() {},
  async mounted() {
    this.setLoading = true;
    this.$store.dispatch("dataContext/setReviewDataSource", []);

    for (let index = 1; index < 201; index++) {
      // var maxID = Math.max(...this.productEntryLocalItems.map((e) => e.ID));

      let dataObj = Object.assign(
        { IsCopyLine: false, IsNewLine: true },
        productEntryBase
      );

      dataObj.ID = index;

      this.productEntryLocalItems.push({ ...dataObj });
    }
    this.initialized();
  },
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },

  computed: {
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    ...mapGetters({
      getValidationSummaryVisible: "ui/getValidationSummaryVisible",
    }),
    backButtonRoute() {
      return "/sales-order";
    },
    getScreenJson() {
      var screenJson = {
        title: "Sales Order",
        endpoint: {
          // primary: this.baseView.mode != "create" ? "SalesOrder" : undefined,
          // // expand: "Customer($select=Name)",
          // // CodeBy: this.baseView.mode == "review" ? "text" : undefined,
          // postProcess: this.salesOrderPostProcess,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              // localDataList: true,
              // items: this.productEntryLocalItems,
            },

            options: {
              keyboardNavigation: {
                enabled: true,
                key: "ID",
                onKeyDownCallBack: this.onDataGridKeyDownCallBack,
              },
              focusedRowEnabled: true,
              repaintChangesOnly: false,
              // wordWrapEnabled: false,
              // selectionMode: 'none'
              onEditorPreparing: this.onEditorPreparing,
              // onFocusedCellChanging: this.onFocusedCellChanging,
              onFocusedCellChanged: this.onFocusedCellChanged,
            },

            dataGridViews:
              // this.baseView.mode != "review"
              //   ?
              [
                {
                  label: "Review",
                  value: "review",
                  default: this.baseView.mode == "review",
                  dataSource: {
                    items: [],
                    postProcessCallback: this.productEntryPostProcess,
                  },
                  columns: this.getProductEntryColumns,
                  visible: this.baseView.mode == "review",
                },
                {
                  label: "Product Entry",
                  value: "product-entry",
                  default: this.baseView.mode != "review",

                  dataSource: {
                    // filter: [["Inactive", "=", "N"]],
                    serverPaging: true,
                    allowGrouping: false,
                    // orderby: "Description1",
                    postProcessCallback: this.productEntryPostProcess,

                    localDataList: true,
                    items: this.productEntryLocalItems,
                  },
                  columns: this.getProductEntryColumns,
                },
              ],
            // : undefined,
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: true,
            save: false,
            audit: false,
            customButtons: [
              {
                label: "Search",
                clickAction: this.visibleProductSearch,
                buttonLocation: "left",
                elementAttr: {
                  class: "cx-color-button",
                },
                visible: this.baseView.mode != "review",
              },
            ],
            // addNew: true,
            // addNewCallBack: this.addNewItemToList,
          },

          columns: this.getProductEntryColumns,

          valueChangedEventListners: [
            {
              dataField: "SalesUM",
              listner: (e, lineData) => {
                lineData.data.SalesUM = e.itemData.SalesUM;
                this.getItemPriceDetails(lineData);
              },
            },
            {
              dataField: "SalesUMQty",
              listner: (e, lineData) => {
                lineData.data.SalesUMQty = e.value;

                // this.mergeWithReviewView(
                //   e.value == 0 ? false : true,
                //   lineData.data
                // );
                this.getItemPriceDetails(lineData);
              },
            },

            {
              dataField: "SalesUMFXPrice",
              listner: (e, lineData) => {
                lineData.data.SalesUMFXPrice = e.value;
                this.onSalesUMFXPriceChanged(e, lineData);
              },
            },

            {
              dataField: "DiscPcnt",
              listner: (e, lineData) => {
                lineData.data.DiscPcnt = e.value;
                this.onSoDetailsDiscountChanged(e, lineData);
              },
            },

            {
              dataField: "ActionDelete",
              listner: (e, lineData, lineParent) => {
                this.onActionDetele(e, lineData, lineParent);
              },
            },
            {
              dataField: "ActionCopy",
              listner: (e, lineData) => {
                this.copyRow(e, lineData);
              },
            },

            {
              dataField: "ActionAddNew",
              listner: (e, lineData) => {
                if (this.dataViewType == "product-entry") {
                  if (!lineData.data.Code) {
                    this.addToValidationSum(
                      "Product can not be empty",
                      lineData,
                      "ProductCode"
                    );
                    return;
                  } else this.addNewItemToList();
                }
              },
            },
          ],
        },
        footerData: {
          footerItems: [
            {
              screenField: "SalesUMItemCount",
              dataField: "SalesUMQty",
              location: "left",
              value: 0,
            },
            {
              screenField: "FXLineTotal",
              dataField: "TaxableFXLineTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-4C",
              label: `Sub Total (${this.model.CurrencyCode})`,
            },
            {
              screenField: "TaxFXTotal",
              dataField: "TaxFXLineTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-4C",
              label: `Tax (${this.model.CurrencyCode})`,
            },
            {
              screenField: "FXTotal",
              dataField: "FXLineTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-4C",
              label: `Total (${this.model.CurrencyCode})`,
            },
          ],
        },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          headerFormVisible: true,
          deliveryAddressItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "DeliveryAddressCompanyName",
                  editorType: "dxTextBox",
                  label: {
                    text: "Name",
                  },
                  editorOptions: {
                    maxLength: "100",
                    readOnly: true,
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine1",
                  dataField: "DeliveryAddressStreetLine1",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" || this.model.Status === "X",
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine2",
                  dataField: "DeliveryAddressStreetLine2",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" || this.model.Status === "X",
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressSuburb",
                  dataField: "DeliveryAddressSuburb",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" || this.model.Status === "X",
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressState",
                  dataField: "DeliveryAddressState",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" || this.model.Status === "X",
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressPostcode",
                  dataField: "DeliveryAddressPostcode",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" || this.model.Status === "X",
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressCountry",
                  dataField: "DeliveryAddressCountry",
                  editorOptions: {
                    maxLength: "50",
                    readOnly:
                      this.model.Status === "C" || this.model.Status === "X",
                  },
                  // allowUpdate: false,
                },
              ],
            },
          ],
          headerToolbar: {
            audit: this.baseView.mode == "review",
            status: true,
            // notes: true,
            // notesItems: ["Order Comments", "Order Notes"],
            save:
              (this.baseView.mode != "edit" &&
                this.model.Status != "C" &&
                this.model.Status != "X") ||
              (this.baseView.mode == "edit" && this.model.Status != "C"),
            editURL: "/sales-order-v2",
            saveOptions: {
              items: this.baseView.id
                ? [
                    { text: "Draft", id: "D" },
                    { text: "Commit", id: "A", default: true },
                    { text: "Cancel", id: "X" },
                  ]
                : [
                    { text: "Draft", id: "D" },
                    { text: "Commit", id: "A", default: true },
                  ],
              keyExpr: "id",
              displayExpr: "text",
              dropDownOptions: {
                width: "150px",
              },
              saveKey: "NextStatus",
            },
            saveCallback: this.saveSalesOrder,
            editCallBack: this.editSOCallBack,
            screenName: "Sales Orders - All",
            pdf: this.baseView.mode == "review",

            toolbarFormItems: [
              {
                screenField: "Customer",
                dataField: "CustomerCode",
                cssClass: "toolbar-customer-label",
                editorOptions: {
                  dropDownOptions: {
                    minWidth: 300,
                  },
                  width: 300,
                  placeholder: "Customer Name",
                  onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                  showClearButton: true,
                  onItemClick: this.onCustomerCodeItemClicked.bind(this),
                },
                label: {
                  text: "Customer",
                  visible: false,
                },
                required: true,
              },
            ],
            formContentReady: this.toolBarFormContentReady,
            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateCreated",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // // disabled: true,
                    },
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // disabled: true,
                    },
                  },
                ],
              },
            ],
            customStatus: {
              enabled: true,
              key: "CustomStatus",
            },
            orderComments: {
              dataField: "SalesOrderTypeCode",
              endpoint: "SalesOrderType",
              toMatch: [
                "UserComment1",
                "UserComment2",
                "UserComment3",
                "UserComment4",
                "UserComment5",
                "UserComment6",
                "UserComment7",
                "UserComment8",
                "UserComment9",
                "UserComment10",
                "UserComment11",
                "UserComment12",
                "UserComment13",
                "UserComment14",
                "UserComment15",
                "UserComment16",
                "UserComment17",
                "UserComment18",
                "UserComment19",
                "UserComment20",
              ],
            },
            commentItems: [
              {
                itemType: "group",
                caption: "",
                items: [],
              },
            ],
          },
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text:
                  this.baseView.mode == "create"
                    ? "Create Sales Order"
                    : "Sales Order # " + this.baseView.id,
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField:
                this.baseView.mode == "create" ? undefined : "CustomerName",
              text: undefined,
            },
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      label: {
                        text: "Date In",
                      },
                      dataField: "DateIn",
                      required: true,
                      editorOptions: {
                        onValueChanged: this.onDateInValueChanged.bind(this),
                      },
                    },
                    {
                      screenField: "RequiredDate",
                      label: {
                        text: "Reqd Date",
                      },
                      dataField: "RequiredByDate",
                      required: true,
                      editorOptions: {
                        onValueChanged: this.onRequiredByDateValueChanged.bind(
                          this
                        ),
                      },
                    },
                    {
                      screenField: "ShipDate",
                      label: {
                        text: "Ship Date",
                      },
                      dataField: "ShipDate",
                      required: true,
                      editorOptions: {
                        onValueChanged: this.onShipDateValueChanged.bind(this),
                      },
                    },
                    {
                      screenField: "CustPO",
                      dataField: "OrderNo",
                      editorOptions: {
                        onValueChanged: this.onOrderNoChanged.bind(this),
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DeliverTo",
                      dataField: "DeliveryAddressCompanyName",
                      ref: "DeliveryAddressCompanyName",
                      required: true,
                      editorOptions: {
                        onItemClick: this.onDeliveryAddressChanged.bind(this),
                        // allowUpdate: true,
                      },
                      dataSourceConfig: {
                        // ingnore: true,
                        data: deliveryAddressDataSourceItems,
                      },
                      visible: this.baseView.mode != "review",
                    },

                    {
                      screenField: "DeliverTo",
                      dataField: "DeliveryAddressCompanyName",
                      ref: "DeliveryAddressCompanyName",
                      required: true,
                      visible: this.baseView.mode == "review",
                    },
                    {
                      screenField: "DeliveryCompanyView",
                      editAddress:
                        this.baseView.mode != "review" ? true : false,
                    },
                    {
                      screenField: "ConNote",
                      dataField: "ConsignmentNo",
                    },
                    {
                      screenField: "CurrencyCode",
                      dataField: "CurrencyCode",
                      editorOptions: {
                        readOnly: true,
                      },
                    },
                    {
                      screenField: "ExchangeRate",
                      dataField: "ExchangeRate",
                      editorOptions: {
                        // TODO: Check the ReadOnly Logic
                        readOnly: true,
                        onValueChanged: this.onExchangeValueChanged,
                      },
                      required: true,
                      validationRules: [
                        {
                          type: "custom",

                          validationCallback: ({ value, rule }) => {
                            rule.message = `Exchange rate Cannot be 0 or Negative`;
                            return value > 0;
                          },
                        },
                      ],
                    },
                  ],
                },

                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Branch",
                      label: {
                        text: "Branch",
                      },
                      dataField: "BranchCode",
                      required: true,
                      editorOptions: {
                        onValueChanged: async (e) => {
                          await this.getSalesUMs(e.value);
                          this.triggerPriceChange(e);
                        },
                      },
                    },
                    {
                      screenField: "Division",
                      label: {
                        text: "Division",
                      },
                      dataField: "DivisionCode",
                      required: true,
                      editorOptions: {
                        onValueChanged: this.triggerPriceChange.bind(this),
                      },
                    },
                    {
                      // dataField: "SalesOrderTypeDescription",
                      screenField: "OrderType",
                      required: true,
                      editorOptions: {
                        onValueChanged: this.triggerPriceChange.bind(this),
                      },
                    },
                    {
                      screenField: "OrderRep",
                      dataField: "SalesRepresentativeCode",
                      label: {
                        text: "Sales Rep",
                      },
                      required: true,
                      // defaultValue: this.getDefaultSalesRep,
                    },
                  ],
                },
              ],
            },
          ],
        },
      };
    },
    getProductEntryColumns() {
      return [
        {
          // screenField: "Comments",
          label: "Product",
          dataField: "ProductCode",
          showEditorAlways: true,
          allowSearch: false,
          allowSorting: false,
          allowEditing: true,
          minWidth: 250,
          // editCellTemplate: "EditableText",
          // valueChangeCallBack: this.onProductCodeChange,
          // onKeyDown: this.onKeyDownCallBack,
          visible: this.dataViewType != "review",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            onValueChanged: this.onProductCodeChange,
            // onFocusIn: (e) => {
            //   e.event.target.select();
            // },
            onKeyDown: this.onKeyDownCallBack,
          },
        },
        {
          screenField: "Comments",
          label: "Description",
          dataField: "ProductDescription",
          showEditorAlways: false,
          allowSearch: true,
          allowSorting: false,
          allowEditing: false,
          minWidth: 250,
          visible: this.dataViewType != "review",
        },
        {
          screenField: "Item",
          showEditorAlways: false,
          allowEditing: false,
          label: "Product",
          visible: this.dataViewType == "review",
        },
        {
          screenField: "SalesUMQty",
          dataField: "SalesUMQty",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          showEditorAlways: this.dataViewType != "review",
          allowSorting: false,
          allowEditing: this.dataViewType != "review",
          allowSearch: false,
          allowFiltering: false,
          // minmax: { min: 0, max: 999999999.99 },
          dataType: "number",
          editorOptions: {
            min: 0,
            max: 999999999.99,
            onValueChanged: (e, lineData) => {
              lineData.data.SalesUMQty = e.value;
              if (lineData.data.Code) this.getItemPriceDetails(lineData);
            },
            onKeyDown: this.onKeyDownCallBack,
            // onKeyUp: (e)=> {
            //   console.log('K UP ', e);
            // },
            // onInput: (e) => {
            //   // console.log("onInput ", e.event.target.value , e);
            //   // console.log("onInput ", Number(e.event.target.value));
            //   // console.log("onInput ", parseFloat(e.event.target.value));
            //   console.log('ON INPUT ', e.component.option().value);
            // },
            mode: "number",
          },
          // onKeyDown: this.onKeyDownCallBack,
        },
        {
          screenField: "SalesUM",
          dataField: "SalesUM",
          showEditorAlways: this.dataViewType != "review",
          allowEditing: this.dataViewType != "review",
          allowSorting: false,
          width: 80,
          minWidth: 80,
          allowSearch: false,
          dataType: "object",
          cssClass: "edit-cell-select-field",
          allowUpdate: true,
          lookup:
            this.dataViewType != "review"
              ? {
                  allowClearing: false,
                  dataSource: (data) => {
                    var dataSource = [];

                    if (data && data.data && data.data.Code) {
                      this.salesUMsLocalData.forEach((element) => {
                        if (element.ItemCode == data.data.Code)
                          dataSource.push(element);
                      });

                      data.data.SLUMLength = dataSource.length;
                    }
                    return dataSource;
                  },
                  displayExpr: "SalesUM",
                  valueExpr: "SalesUM",
                }
              : undefined,
          editorOptions: {
            dropDownOptions: {
              minWidth: 100,
            },
            onKeyDown: this.onKeyDownCallBack,
          },
        },
        {
          screenField: "SalesUMFXPrice",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          showEditorAlways: this.dataViewType != "review",
          // type: "Decimal"
          gridLabel: `Price (${this.model.CurrencyCode})`,
          allowSorting: false,
          allowSearch: false,
          allowEditing: this.dataViewType != "review",
          width: 150,
          minWidth: 150,
          // onKeyDown: this.onKeyDownCallBack,
          editorOptions: {
            onValueChanged: (e, lineData) => {
              lineData.data.SalesUMFXPrice = e.value;
              this.onSalesUMFXPriceChanged(e, lineData);
            },
            onKeyDown: this.onKeyDownCallBack,
          },
        },
        {
          screenField: "DiscountPercent",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          showEditorAlways: this.dataViewType != "review",
          allowEditing: this.dataViewType != "review",
          allowSorting: false,
          allowSearch: false,
          width: 150,
          minWidth: 150,
          // onKeyDown: this.onKeyDownCallBack,
          editorOptions: {
            onValueChanged: (e, lineData) => {
              lineData.data.DiscPcnt = e.value;
              this.onSoDetailsDiscountChanged(e, lineData);
            },
            onKeyDown: this.onKeyDownCallBack,
          },
        },
        {
          screenField: "SalesUMNetFXPrice",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          allowEditing: false,
          // type: "Decimal"
          gridLabel: `Net (${this.model.CurrencyCode})`,
          allowSorting: false,
          allowSearch: false,
          width: 150,
          minWidth: 150,
        },
        {
          screenField: "TaxableFXLineTotal",
          // type: "EditableDecimal",
          type: "DefaultDecimal",
          allowEditing: false,
          // type: "Decimal"
          gridLabel: `Total (${this.model.CurrencyCode})`,
          allowSorting: false,
          allowSearch: false,
          width: 150,
          minWidth: 150,
        },
        {
          dataField: "ActionDelete",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionDelete",
          visible: this.baseView.mode != "review",
          cssClass: "class-custom-btn",
        },
        {
          dataField: "ActionCopy",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionCopy",
          visible: this.baseView.mode != "review",
          cssClass: "class-custom-btn",
          allowSearch: false,
          allowFiltering: false,
        },
        {
          dataField: "ActionAddNew",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionAddNew",
          visible:
            this.baseView.mode != "review" &&
            this.dataViewType == "product-entry",
          cssClass: "class-custom-btn",
        },
      ];
    },
    getSelectedViewType() {
      if (this.baseView.mode == "review") return "review";
      return this.dataViewType;
    },
    isEditVisible() {
      if (this.baseView.mode == "create") return true;
      else {
        return (
          this.$refs["sales-order-v2"].getTransactionData().Status !== "C" &&
          this.$refs["sales-order-v2"].getTransactionData().Status !== "X"
        );
      }
    },
  },
  methods: {
    onDataGridKeyDownCallBack(e) {
      if (e.event.code == "Tab" && this.getValidationSummaryVisible)
        e.event.preventDefault();
    },
    toolBarFormContentReady(e) {
      if (e)
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm)
            headerToolBarForm
              .getEditor("CustomerCode")
              .instance()
              .focus();
        }, 500);
    },
    // onFocusedCellChanging(e) {
    //   if (e.columns[e.newColumnIndex].dataField === "SalesUM") {
    //     var id = e.component.getKeyByRowIndex(e.newRowIndex);
    //     var index = e.rows.findIndex((x) => x.data.ID == id);
    //     if (index != -1 && e.rows[index].data.SLUMLength == 1) {
    //       if (e.newColumnIndex > e.prevColumnIndex) e.newColumnIndex += 1;
    //       else e.newColumnIndex -= 2;
    //     }
    //   }
    // },
    onFocusedCellChanged(e) {
      this.focusedCell = e;
    },
    onEditorPreparing(e) {
      if (e.dataField == "SalesUM") {
        if (e.row.data.SLUMLength == 1) {
          e.allowEditing = false;
          e.allowUpdate = false;
          e.showEditorAlways = false;
          e.editorOptions.readOnly = true;
          // e.editorOptions.disabled = true;
          e.editorName = "dxTextBox";
        }
      }

      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        e.editorOptions.onKeyDown = (event) => {
          func(event, {
            column: {
              dataField: e.dataField,
            },
            data: e.row.data,
            rowIndex: e.row.rowIndex,
          });
        };
      }

      if (e.editorOptions && e.editorOptions.onValueChanged) {
        let func = e.editorOptions.onValueChanged;
        e.editorOptions.onValueChanged = (event) => {
          func(event, {
            column: {
              dataField: e.dataField,
            },
            data: e.row.data,
            rowIndex: e.row.rowIndex,
          });
        };
      }
    },
    async visibleProductSearch() {
      const headerToolbarForm = await validationEngine.validateGroup(
        "gc-form-header-toolbar"
      );

      if (!headerToolbarForm.isValid) {
        this.validationLineData = "Customer";
        this.$refs["sales-order-v2"].showValidationSummary(
          headerToolbarForm.brokenRules
        );
        return;
      } else {
        this.searchForItem = {
          visible: true,
          popUpCallBack: this.visibleProductSearchCallBack,
          productListQuery: {
            url: "api/ProductFilterGroupSaleItemCompanyBranch",
            filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
            select: [
              "ItemCode",
              "Description1",
              "BranchCode",
              "CustomerCode",
              "Inactive",
              "ItemType",
              "SalesUM",
              "StockUM",
            ],
          },
          columns: [
            {
              screenField: "Comments",
              label: "Product",
              dataField: "ItemCode",
            },
            {
              screenField: "Comments",
              label: "Description",
              dataField: "Description1",
            },
          ],
          productListItems: this.productListItems,
        };
      }
    },
    visibleProductSearchCallBack(data, productListItems) {
      this.productListItems = productListItems;
      this.searchForItem = {
        visible: false,
        popUpCallBack: this.visibleProductSearchCallBack,
        productListItems: productListItems,
      };
      if (data) {
        var dataGrid = this.$refs["sales-order-v2"].$refs[
          "transactionGrid"
        ].getGridInstance();

        var dataRows = dataGrid.getVisibleRows();
        var dataRow = dataRows[dataRows.length - 1];

        if (dataRow) {
          if (dataRow.data.Code == undefined) {
            this.onProductCodeChange(
              { event: true, value: data.ItemCode },
              {
                column: {
                  dataField: "ProductCode",
                },
                data: dataRow.data,
                rowIndex: dataRow.rowIndex,
              }
            );
            // this.addNewItemToList();
          } else {
            this.addNewItemToList();
            setTimeout(() => {
              this.visibleProductSearchCallBack(data, productListItems);
            }, 500);
          }
        }
      }
    },
    HeaderFormInstance() {
      if (this.loaded)
        return this.$refs["sales-order-v2"].$refs["gc-header-form-component"]
          .$refs["gc-header-form"].$refs["gc-form-comp"].instance;
    },
    DeliveryAddressCompanyNameEditor() {
      if (this.loaded) {
        return this.HeaderFormInstance().getEditor(
          "DeliveryAddressCompanyName"
        );
      }
    },
    ExchangeRateEditor() {
      return this.HeaderFormInstance().getEditor("ExchangeRate");
    },
    async salesOrderPostProcess(data) {
      data.CustomerDeliveryAddressLineNo = data.CustomerDeliveryAddressLineNo.split(
        " "
      )[0];

      await CompanyService.getByCompanyCode(data.CompanyCode).then((res) => {
        data.CurrencyCode = res.data.value[0].CurrencyCode;
        data.CompanyCurrency = res.data.value[0].CurrencyCode;
      });

      this.setDeliveryAddressDataSourceItems(
        data.CustomerCode,
        data.CustomerDeliveryAddressLineNo
      );

      this.model = data;
      return data;
    },
    async onKeyDownCallBack(e, lineData) {
      if (this.getValidationSummaryVisible) e.event.preventDefault();

      var dataGrid = this.$refs["sales-order-v2"].$refs[
        "transactionGrid"
      ].getGridInstance();

      this.enterNewLine = false;
      // this.newLineID = undefined;

      if (this.dataViewType != "review") {
        if (
          (e.event.code == "Enter" || e.event.code == "NumpadEnter") &&
          e.event.key == "Enter"
        ) {
          if (lineData.column.dataField == "ProductCode")
            this.enterNewLine = true;
          const headerToolbarForm = await validationEngine.validateGroup(
            "gc-form-header-toolbar"
          );

          if (!headerToolbarForm.isValid) {
            this.validationLineData = "Customer";
            this.$refs["sales-order-v2"].showValidationSummary(
              headerToolbarForm.brokenRules
            );
            return;
          } else {
            if (
              lineData.column.dataField != "ProductCode"
              //  && lineData.data.ProductCode
            ) {
              // this.addNewItemToList();

              var rowIndex = this.getRowIndexToEdit(dataGrid, lineData.data.ID);

              if (rowIndex + 1 < 50) {
                this.focusOnGridCell(rowIndex + 1, "ProductCode");
              } else this.addNewItemToList();
            }
            // else this.enterNewLine = true;
            else if (
              lineData.column.dataField != "ProductCode" &&
              !lineData.data.ProductCode
            ) {
              this.addToValidationSum(
                "Product can not be empty",
                lineData,
                "ProductCode"
              );
            } else {
              let rowIndex = this.getRowIndexToEdit(dataGrid, lineData.data.ID);

              if (rowIndex + 1 < 50) {
                this.focusOnGridCell(rowIndex + 1, "ProductCode");
              }
            }
          }
        }
      }
    },
    editSOCallBack() {
      this.$store.dispatch("dataContext/setDataViewType", "product-entry");
    },
    onSoDetailsDiscountChanged(e, lineData) {
      let newDiscPcnt = e.value;

      let record = lineData.data;

      record.DiscPcnt = newDiscPcnt;

      record.SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
        record.SalesUMFXPrice,
        record.DiscPcnt
      );
      this.setBaseCurrencyPriceFromFXPrice(record);

      this.mergeWithReviewView(record.SalesUMQty == 0 ? false : true, record);
    },
    onSalesUMFXPriceChanged(e, lineData) {
      let newsalesUMFXPrice = e.value;

      let record = lineData.data;

      record.SalesUMFXPrice = newsalesUMFXPrice;
      record.SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
        newsalesUMFXPrice,
        record.DiscPcnt
      );

      this.setBaseCurrencyPriceFromFXPrice(record);

      this.mergeWithReviewView(record.SalesUMQty == 0 ? false : true, record);
    },

    setBaseCurrencyPriceFromFXPrice(record) {
      record.SalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
        record.SalesUMFXPrice,
        this.model.ExchangeRate
      );

      record.CalculatedDiscPcnt = calculateCalculatedDiscPcnt(
        record.SalesUMStandardPrice,
        record.SalesUMPrice
      );

      record.SalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        record.SalesUMNetFXPrice,
        this.model.ExchangeRate
      );

      this.setStockPrices(record);
      this.setLineTotals(record);
    },

    setStockPrices(record) {
      record.StockUMQty = calculateStockUMQty(
        record.SalesUMQty,
        record.SalesUMConversion
      );

      // Stock
      record.StockUMFXPrice = calculateStockUMFXPrice(
        record.SalesUMFXPrice,
        record.SalesUMConversion
      );

      record.StockUMNetFXPrice = calculateStockUMNetFXPrice(
        record.SalesUMNetFXPrice,
        record.SalesUMConversion
      );

      record.StockUMPrice = calculateStockUMPrice(
        record.SalesUMPrice,
        record.SalesUMConversion
      );

      record.StockUMNetPrice = calculateStockUMNetPrice(
        record.SalesUMNetPrice,
        record.SalesUMConversion
      );
    },
    setLineTotals(record) {
      // FX Totals
      record.DiscFXLineTotal = calculateDiscFXLineTotal(
        record.SalesUMFXPrice,
        record.SalesUMNetFXPrice,
        record.SalesUMQty
      );
      record.NetFXLineTotal = calculateNetFXLineTotal(
        record.SalesUMNetFXPrice,
        record.SalesUMQty
      );
      record.WetFXLineTotal = calculateWetFXLineTotal(
        record.NetFXLineTotal,
        record.WetPcnt
      );

      record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal
      );
      record.TaxFXLineTotal = calculateTaxFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
        record.SalesTaxPcnt
      );
      record.FXLineTotal = calculateFXLineTotal(
        record.TaxableFXLineTotal,
        record.TaxFXLineTotal
      );

      // Totals
      record.DiscLineTotal = calculateDiscLineTotal(
        record.DiscFXLineTotal,
        this.model.ExchangeRate
      );
      record.NetLineTotal = calculateNetLineTotal(
        record.NetFXLineTotal,
        this.model.ExchangeRate
      );
      record.WetLineTotal = calculateWetLineTotal(
        record.WetFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxableLineTotal = calculateTaxableLineTotal(
        record.TaxableFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxLineTotal = calculateTaxLineTotal(
        record.TaxFXLineTotal,
        this.model.ExchangeRate
      );
      record.LineTotal = calculateLineTotal(
        record.FXLineTotal,
        this.model.ExchangeRate
      );
      // window.ViewModel.calculateComputedFields();
    },
    async getItemPriceDetails(lineData) {
      if (!lineData.data.ItemCode) return;
      // this.setLoading = true;
      await SalesOrderV2Service.setSaleItemPrice(
        // Non Grid List
        lineData.data,
        this.model.SalesOrderTypeCode,
        this.model.BranchCode,
        this.model.CustomerCode,
        this.model.ExchangeRate,
        this.model.DateIn,
        this.model.RequiredByDate,
        false

        // eslint-disable-next-line no-unused-vars
      ).then(async (res) => {
        if (res)
          this.mergeWithReviewView(
            lineData.data.SalesUMQty == 0 ? false : true,
            lineData.data
          );
      });

      this.setLoading = false;
    },
    async onProductCodeChange(e, lineData) {
      if (!e.event) return;
      // e.event.preventDefault();

      const headerToolbarForm = await validationEngine.validateGroup(
        "gc-form-header-toolbar"
      );

      if (!headerToolbarForm.isValid) {
        lineData.data[lineData.column.dataField] = e.previousValue;

        e.component.beginUpdate();
        e.component.option("value", e.previousValue);
        e.component.endUpdate();
        this.validationLineData = "Customer";
        this.$refs["sales-order-v2"].showValidationSummary(
          headerToolbarForm.brokenRules
        );
        return;
      } else {
        if (e.value == "") {
          this.addToValidationSum(
            "Product can not be empty",
            lineData,
            "ProductCode"
          );
          return;
        } else {
          lineData.data[lineData.column.dataField] = e.value;
          lineData.data.IsNewLine = false;
        }
      }

      // this.setLoading = true;
      var index = this.productDataSourceItems.findIndex(
        (x) => x.ItemCode == e.value
      );
      if (index == -1) {
        if (lineData.data.validCode) {
          lineData.data[lineData.column.dataField] = lineData.data.validCode;
        }
        lineData.data.IsNewLine = true;
        this.setLoading = false;
        this.enterNewLine = false;
        // if (err)
        this.addToValidationSum(
          "This Product does not exist. Please try again",
          lineData
        );

        setTimeout(() => {
          this.focusOnGridCell(lineData.rowIndex, "ProductCode");
        }, 500);
      } else {
        var productItems = this.productDataSourceItems[index];
        if (productItems) {
          lineData.data.ProductDescription = productItems.Description1;
          lineData.data.SalesUM = productItems.SalesUM;
          // lineData.data.SalesUMQty = 0;
          lineData.data.ItemCode = productItems.ItemCode;
          lineData.data.Code = productItems.ItemCode;
          lineData.data.ItemType = productItems.ItemType;
          lineData.data.validCode = productItems.ItemCode;

          var data = this.reviewDataSource.filter(
            (x) => x.Code == productItems.ItemCode
          );

          if (data.length > 1) {
            lineData.data.IsCopyLine = true;
            lineData.data.CopyCode =
              lineData.data.Code + "-" + (data.length + 1);
          }
          if (lineData.data.SalesUMQty > 0) this.getItemPriceDetails(lineData);

          if (this.enterNewLine) {
            this.addNewItemToList(lineData.rowIndex);
          }
        }
      }

      // this.setLoading = true;
      // await ProductService.getByCodeProductFilterGroupSaleItemCompanyBranch({
      //   filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and ItemCode eq '${e.value}' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
      //   // ((ItemType eq 'S') and (IsDefault eq 'Y') and (AvailableForSale eq 'Y')) and ((CustomerCode eq '10024') and (Inactive eq 'N') and (BranchCode eq '01'))
      //   select: [
      //     "ItemCode",
      //     "Description1",
      //     "BranchCode",
      //     "CustomerCode",
      //     "Inactive",
      //     "ItemType",
      //     "SalesUM",
      //     "StockUM",
      //   ],
      // })
      //   .then(async (res) => {
      //     this.setLoading = false;

      //     // console.log("++++++++ ", lineData.data.SalesUMQty);

      //     if (res.data.value.length > 0) {
      //       lineData.data.ProductDescription = res.data.value[0].Description1;
      //       lineData.data.SalesUM = res.data.value[0].SalesUM;
      //       // lineData.data.SalesUMQty = 0;
      //       lineData.data.ItemCode = res.data.value[0].ItemCode;
      //       lineData.data.Code = res.data.value[0].ItemCode;
      //       lineData.data.ItemType = res.data.value[0].ItemType;
      //       lineData.data.validCode = res.data.value[0].ItemCode;

      //       var data = this.reviewDataSource.filter(
      //         (x) => x.Code == res.data.value[0].ItemCode
      //       );

      //       if (data.length > 1) {
      //         lineData.data.IsCopyLine = true;
      //         lineData.data.CopyCode =
      //           lineData.data.Code + "-" + (data.length + 1);
      //       }
      //       if (lineData.data.SalesUMQty > 0)
      //         this.getItemPriceDetails(lineData);

      //       // this.mergeWithReviewView(
      //       //   lineData.data.SalesUMQty == 0 ? false : true,
      //       //   lineData.data
      //       // );

      //       // await SalesOrderService.getSaleItemCompanyBranchProduct(lineData.data.Code, this.model.BranchCode).then((data) => {
      //       //   console.log('>>> ', data);
      //       // }).catch((dataErr) => {
      //       //   console.log('>>> err ', dataErr);
      //       // })

      //       // await setTimeout(async () => {
      //       //   var dataGrid =
      //       //     this.$refs["sales-order-v2"].$refs[
      //       //       "transactionGrid"
      //       //     ].getGridInstance();

      //       //   // if (lineData.data.SLUMLength == 1)
      //       //   dataGrid.repaintRows([lineData.rowIndex]);
      //       //   // this.$refs["sales-order-v2"].$refs[
      //       //   //   "transactionGrid"
      //       //   // ].gridRepaint2();
      //       // }, 500);

      //       if (this.enterNewLine) {
      //         this.addNewItemToList();
      //       } else {
      //         // var SalesUMs = [];
      //         // this.salesUMsLocalData.forEach((element) => {
      //         //   if (element.ItemCode == lineData.data.Code)
      //         //     SalesUMs.push(element);
      //         // });
      //         // if (
      //         //   this.focusedCell &&
      //         //   this.focusedCell.column.dataField != "SalesUMFXPrice"
      //         // )
      //         //   if (SalesUMs.length == 1) {
      //         //     this.focusOnGridCell(lineData.rowIndex, "SalesUMQty");
      //         //   } else this.focusOnGridCell(lineData.rowIndex, "SalesUM");
      //       }
      //     } else {
      //       this.enterNewLine = false;
      //       if (lineData.data.validCode) {
      //         lineData.data[lineData.column.dataField] =
      //           lineData.data.validCode;
      //       }
      //       this.addToValidationSum(
      //         "This Product does not exist. Please try again",
      //         lineData
      //       );

      //       this.focusOnGridCell(lineData.rowIndex, "ProductCode");
      //     }
      //   })
      //   .catch((err) => {
      //     if (lineData.data.validCode) {
      //       lineData.data[lineData.column.dataField] = lineData.data.validCode;
      //     }
      //     lineData.data.IsNewLine = true;
      //     this.setLoading = false;
      //     this.enterNewLine = false;
      //     if (err)
      //       this.addToValidationSum(
      //         "This Product does not exist. Please try again",
      //         lineData
      //       );

      //     setTimeout(() => {
      //       this.focusOnGridCell(lineData.rowIndex, "ProductCode");
      //     }, 500);
      //   });
    },
    focusOnGridCell(rowIndex, dataField) {
      var dataGrid = this.$refs["sales-order-v2"].$refs[
        "transactionGrid"
      ].getGridInstance();

      setTimeout(() => {
        if (this.getValidationSummaryVisible) return;
        if (rowIndex != -1) {
          var cellElement = dataGrid.getCellElement(rowIndex, dataField);
          dataGrid.focus(cellElement);
          dataGrid.editCell(rowIndex, dataField);

          //     // if (this.newLineID != undefined) {
          //     //   var index = this.productEntryLocalItems.findIndex(
          //     //     (x) => x.ID == this.newLineID
          //     //   );
          //     //   if (index != -1) this.productEntryLocalItems.splice(index, 1);
          //     // }
        }
      }, 500);
    },
    addNewItemToList(rowIndex) {
      this.enterNewLine = false;
      if (
        this.dataViewType == "product-entry" &&
        !this.productEntryLocalItems[this.productEntryLocalItems.length - 1]
          .IsNewLine
      ) {
        var maxID = Math.max(...this.productEntryLocalItems.map((e) => e.ID));

        let dataObj = Object.assign(
          { IsCopyLine: false, IsNewLine: true },
          productEntryBase
        );

        dataObj.ID = ++maxID;

        this.newLineID = dataObj.ID;

        this.productEntryLocalItems.push({ ...dataObj });
        // this.$refs["sales-order-v2"].$refs["transactionGrid"].setDataSource(
        //   this.productEntryLocalItems
        // );

        var dataGrid = this.$refs["sales-order-v2"].$refs[
          "transactionGrid"
        ].getGridInstance();

        // console.log("X 1 ", dataGrid.getVisibleRows());

        // var items = dataGrid.getDataSource().items();
        // items.push({ ...dataObj });
        // dataGrid.repaintRows([items.length - 1]);

        // dataGrid.addRow(dataObj);

        setTimeout(() => {
          var rowIndex = this.getRowIndexToEdit(dataGrid, dataObj.ID);

          if (rowIndex != -1) {
            var cellElement = dataGrid.getCellElement(rowIndex, "ProductCode");
            dataGrid.focus(cellElement);
            dataGrid.editCell(rowIndex, "ProductCode");
          }
        }, 300);
      } else {
        this.focusOnGridCell(
          rowIndex ? rowIndex + 1 : this.productEntryLocalItems.length - 1,
          "ProductCode"
        );

        // var dataGrid =
        //   this.$refs["sales-order-v2"].$refs[
        //     "transactionGrid"
        //   ].getGridInstance();
        // var rowIndex = this.getRowIndexToEdit(dataGrid, lineData.data.ID);

        // console.log("@@@ ", rowIndex, rowIndex + 1, lineData);

        // if (rowIndex + 1 < 50) {
        //   this.focusOnGridCell(rowIndex + 1, "ProductCode");
      }
    },

    getRowIndexToEdit(dataGrid, key) {
      var rowIndex = dataGrid.getRowIndexByKey(key);

      if (rowIndex != -1) return rowIndex;
      else this.getRowIndexToEdit(dataGrid, key);
    },

    async onCustomerCodeValueChanged(e) {
      logDev("onCustomerCodeValueChanged", e);

      if (!e.value) this.model.CustomStatus = null;
      this.productListItems = undefined;

      // if (proceedWithCustomerClick) {
      //   return;
      // }

      // if (e.previousValue && e.value) {
      //   this.triggerPriceChange();
      //   proceedWithCustomerClick = true;
      //   e.component.option("value", e.previousValue);
      // }

      if (!e.value && e.event) {
        this.model.DeliveryAddressCompanyName = "";
        this.model.DeliveryAddressCountry = "";
        this.model.DeliveryAddressPostcode = "";
        this.model.DeliveryAddressState = "";
        this.model.DeliveryAddressStreetLine1 = "";
        this.model.DeliveryAddressStreetLine2 = "";
        this.model.DeliveryAddressSuburb = "";
        this.DeliveryAddressCompanyNameEditor().option("dataSource", []);
        return;
      }

      if (!e.event && e.value) {
        this.setDeliveryAddressDataSourceItems(e.value);
      }

      this.triggerPriceChange(e);
    },

    async onCustomerCodeItemClicked(e) {
      logDev("onCustomerCodeItemClicked", e.itemData);

      // if (proceedWithCustomerClick) {
      //   proceedWithCustomerClick = false;
      //   return;
      // }

      if (e.itemData.StopCredit == "Y") this.model.CustomStatus = "Credit Hold";
      else this.model.CustomStatus = undefined;

      let customerRecord = e.itemData;
      if (!customerRecord) {
        return;
      }

      this.model.CustomerCode = customerRecord.Code;
      this.model.CurrencyCode = customerRecord.CurrencyCode;
      await this.setProductDataSourceItems();

      this.setExchangeRateProperties();
      this.setDeliveryAddressDataSourceItems(this.model.CustomerCode);

      this.focusOnGridCell(0, "ProductCode");
    },

    setSaleItemPriceAllLines() {
      if (this.reviewDataSource.length > 0) {
        var promises = [];
        // let factor616DateForPriceGroupPriceSelection = getFactorByCode(616);
        // if (factor616DateForPriceGroupPriceSelection.Factorc != "Date In")
        for (var i = 0; i < this.productEntryLocalItems.length; i++) {
          var record = this.productEntryLocalItems[i];
          if (record.ItemCode)
            promises.push(
              SalesOrderV2Service.setSaleItemPrice(
                // REPRICE ALL
                record,
                this.model.SalesOrderTypeCode,
                this.model.BranchCode,
                this.model.CustomerCode,
                this.model.ExchangeRate,
                this.model.DateIn,
                new Date(this.model.RequiredByDate),
                false
              )
            );
        }

        Promise.all(promises).then(function() {
          // this.$logger.debug("All SO details line prices are set");
          // that.refreshView();
          // console.log(">>>> ", data);
        });

        // // update the promotion state of line items in the Sales Order Detail List
        // var primaryList = window.ViewModel.getListByName("Sales Order Detail List");
        // var currentActiveViewListRecords = primaryList.getActiveAlternateViewListRecords();

        // new SalesItemPromotionHelper().loadSalesItemPromotion(primaryList.ListRecords, currentActiveViewListRecords);
      }
    },

    async setExchangeRateProperties() {
      let isEditable = false;

      if (
        !(
          this.baseView.mode == "review" ||
          this.factor368ExchangeRateFieldEditable == "N"
        )
      ) {
        isEditable = this.model.CompanyCurrency != this.model.CurrencyCode;
      }

      if (this.ExchangeRateEditor())
        this.ExchangeRateEditor().option("readOnly", !isEditable);

      if (this.model.CompanyCurrency != this.model.CurrencyCode) {
        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode
        );
        this.model.ExchangeRate = result.data.value[0].BuyRate;
      } else {
        this.model.ExchangeRate = 1;
      }
    },

    async onExchangeValueChanged(e) {
      if (!e.event) return;
      // if (this.isExchangeReverting) {
      //   this.isExchangeReverting = false;
      //   return;
      // }
      // if (e.value === 0) {
      //   this.displayValidationSummary([
      //     "Exchange rate should be greater than 0.0000",
      //   ]);
      //   this.isExchangeReverting = true;
      //   this.model.ExchangeRate = e.previousValue;
      // } else {
      //   this.setCompanyCurrencyPriceAllLines();
    },

    async onDeliveryAddressChanged(e) {
      this.model.CustomerDeliveryAddressLineNo = e.itemData.LineNo;
    },

    async onOrderNoChanged(e) {
      if (!e.event) return;
    },
    async onShipDateValueChanged(e) {
      if (!e.event) return;
    },
    async onRequiredByDateValueChanged(e) {
      if (!e.event) return;
      let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

      if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
        this.model.ShipDate = e.value;
      }
      if (getFactorByCode(616).Factorc != "Date In") {
        this.triggerPriceChange(e);
      }
    },
    async onDateInValueChanged(e) {
      if (!e.event) return;
      if (e.event && getFactorByCode(616).Factorc == "Date In") {
        this.triggerPriceChange(e);
      }
    },
    triggerPriceChange(e) {
      // alert("Price Change Trigger logic");
      if (e.event) this.setSaleItemPriceAllLines();
    },

    addToValidationSum(message, lineData, dataField) {
      this.validationLineData = lineData;
      this.validationDataField = dataField;
      this.validationSummary = [];
      this.validationSummary.push({
        message: message,
      });
    },
    copyRow(e, lineData) {
      lineData.data.CopyTriggered = true;
      let dataObj = Object.assign(
        { IsCopyLine: true, IsNewLine: false },
        lineData.data
      );
      dataObj.IsCopyLine = true;
      dataObj.LineNo = 0;
      dataObj.CopyTriggered = false;
      // dataObj.SalesUMQty = 0;

      var data = this.reviewDataSource.filter((x) => x.Code == dataObj.Code);
      dataObj.CopyCode = dataObj.Code + "-" + (data.length + 1);

      var maxID = Math.max(...this.productEntryLocalItems.map((e) => e.ID));
      dataObj.ID = ++maxID;

      // items.splice(lineData.rowIndex + 1, 0 , dataObj);

      // if (this.dataViewType == "product-entry") {
      if (!lineData.data.Code) {
        this.addToValidationSum(
          "Product can not be empty",
          lineData,
          "ProductCode"
        );
        return;
      }
      // else {
      //     // this.productEntryLocalItems.push({ ...dataObj });
      //   }
      // }

      this.productEntryLocalItems.push({ ...dataObj });
      this.addToReview({ ...dataObj });

      this.$refs["sales-order-v2"].$refs["transactionGrid"].gridRepaint();

      var dataGrid = this.$refs["sales-order-v2"].$refs[
        "transactionGrid"
      ].getGridInstance();

      setTimeout(() => {
        var rowIndex = this.getRowIndexToEdit(dataGrid, dataObj.ID);

        if (rowIndex != -1) {
          var cellElement = dataGrid.getCellElement(rowIndex, "ProductCode");
          dataGrid.focus(cellElement);
          dataGrid.editCell(rowIndex, "ProductCode");
        }
      }, 500);
    },
    async saveSalesOrder(e) {
      if (this.reviewDataSource.length === 0) {
        this.addValidations(
          "Sales Order has no detail. Please add one or more lines before attempting to save the transaction again."
        );
        return;
      }

      if (e.NextStatus == "X") {
        let confirmLeaving = await this.$confirm(
          "Do you really wish to cancel sales order?",
          "Cancel sales order"
        );

        if (confirmLeaving) {
          this.$logger.trackEventButtonClick("Cancel Sales Order");
          this.cancelSalesOrder();
        }
      } else {
        if (this.baseView.mode != " create")
          this.model = this.$refs["sales-order-v2"].getTransactionData();
        let payload = this.getSavePayload();

        this.setLoading = true;
        await SalesOrderV2Service.saveSalesOrder(payload, payload.Code)
          .then((res) => {
            this.setLoading = false;

            if (this.baseView.mode == "create") {
              this.model.Code = res.data.Code;
            }

            this.$notify(
              `Sales Order ${this.model.Code} Successfully Saved`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/sales-order`,
            });
            // this.$router
            //   .push({
            //     path: `/sales-order-v2/review/${this.model.Code}`,
            //   })
            //   .then(() => {
            //     this.$store.dispatch("dataContext/setDataViewType", "review");

            //     this.reload = true;
            //     this.loaded = false;
            //     this.$store.dispatch("dataContext/setReviewDataSource", []);
            //     this.productEntryLocalItems = [];
            //     this.initialized();
            //   });
          })
          .catch((error) => {
            this.setLoading = false;
            this.serverError = {
              err: error,
              msg: "Save Sales Order Failed",
              time: new Date().getTime(),
            };
          });
      }
    },
    async cancelSalesOrder() {
      this.setLoading = true;
      var payload = {
        Code: this.baseView.id,
      };
      await SalesOrderService.cancelSalesOrder(payload)
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.setLoading = false;
          // this.$logger.debug("result ", result);
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/sales-order`,
          });
        })
        .catch((error) => {
          this.setLoading = false;

          this.setLoading = false;
          this.serverError = {
            err: error,
            msg: "Cancel sales order Failed",
            time: new Date().getTime(),
          };
        });
    },

    getSavePayload() {
      var ExTaxTotal = 0;
      var TaxTotal = 0;
      var Total = 0;
      this.reviewDataSource.forEach((element) => {
        ExTaxTotal = ExTaxTotal + element.TaxableFXLineTotal;
        TaxTotal = TaxTotal + element.TaxFXLineTotal;
        Total = Total + element.FXLineTotal;
      });
      let payload = {
        BranchCode: this.model.BranchCode,
        Code: this.baseView.id ? parseInt(this.baseView.id) : 0,
        CompanyCode: this.model.CompanyCode,
        ConsignmentNo: this.model.ConsignmentNo,
        CurrencyCode: this.model.CurrencyCode,
        CustomerCode: this.model.CustomerCode,
        CustomerDeliveryAddressLineNo: this.model.CustomerDeliveryAddressLineNo.toString(),
        DateIn: new Date(this.model.DateIn).toSaveDate(),
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        Status: this.model.NextStatus,
        DivisionCode: this.model.DivisionCode,
        ExchangeRate: this.model.ExchangeRate,
        ExTaxTotal: parseFloat(ExTaxTotal.toFixed(2)),
        ItemCount: this.reviewDataSource.length,
        OrderNo: "",
        RequiredByDate: new Date(this.model.RequiredByDate).toSaveDate(),
        SalesOrderTypeCode: this.model.SalesOrderTypeCode,
        SalesRepresentativeCode: this.model.SalesRepresentativeCode,
        ShipDate: new Date(this.model.ShipDate).toSaveDate(),
        // Status: "A",
        TaxTotal: parseFloat(TaxTotal.toFixed(2)),
        Total: parseFloat(Total.toFixed(2)),
        UserComment1: this.model.UserComment1,
        UserComment2: this.model.UserComment2,
        UserComment3: this.model.UserComment3,
        UserComment4: this.model.UserComment4,
        UserComment5: this.model.UserComment5,
        UserComment6: this.model.UserComment6,
        UserComment7: this.model.UserComment7,
        UserComment8: this.model.UserComment8,
        UserComment9: this.model.UserComment9,
        UserComment10: this.model.UserComment10,
        UserComment11: this.model.UserComment11,
        UserComment12: this.model.UserComment12,
        UserComment13: this.model.UserComment13,
        UserComment14: this.model.UserComment14,
        UserComment15: this.model.UserComment15,
        UserComment16: this.model.UserComment16,
        UserComment17: this.model.UserComment17,
        UserComment18: this.model.UserComment18,
        UserComment19: this.model.UserComment19,
        UserComment20: this.model.UserComment20,

        SalesOrderDetails: this.getSalesOrderDetailPayload(),
        SalesOrderNotes: [],
      };

      if (this.model.Notes && this.model.Notes.length > 0) {
        let notes = this.model.Notes.map((note) => {
          let n = {
            LineNo: note.LineNo ? note.LineNo : 0,
            Note: note.Note,
          };
          return n;
        });
        payload.SalesOrderNotes = notes;
      }

      // delete payload.Status;
      // if (this.baseView.mode == "create") delete payload.Code;

      if (this.baseView.mode != "create") {
        payload.DateChanged = this.model.DateChanged;
      }
      return payload;
    },

    getSalesOrderDetailPayload() {
      let details = [];

      this.reviewDataSource.forEach((data) => {
        let detailObj = {
          SalesOrderCode: data.SalesOrderCode ? data.SalesOrderCode : 0,
          LineNo: data.LineNo ? data.LineNo : 0,
          ItemCode: data.ItemCode,
          SalesUM: data.SalesUM,
          SalesUMQty: data.SalesUMQty,
          DiscPcnt: data.DiscPcnt,
          SalesUMPrice: data.SalesUMFXPrice,
          Comment: data.Comment,
          RecordId: "00000000-0000-0000-0000-000000000000",
        };

        details.push(detailObj);
      });

      return details;
    },

    addValidations(message) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: message,
      });
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    addToReview(item) {
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    async removeFromReview(index, item) {
      if (item) this.reviewDataSource.splice(index, 1, item);
      else this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    mergeWithReviewView(value, item) {
      var index = undefined;

      // if (!item.IsCopyLine)
      //   index = this.reviewDataSource.findIndex((x) => x.Code == item.Code);
      // else
      index = this.reviewDataSource.findIndex(
        (x) => x.Code == item.Code && x.ID == item.ID
      );

      if (!value) {
        if (index != -1) {
          this.removeFromReview(index);
        }
      } else {
        if (index != -1) {
          this.removeFromReview(index, item);
        } else this.addToReview(item);
        // this.setLineNo();
      }
    },
    detailsViewChanged(e) {
      this.$store.dispatch("dataContext/setDataViewType", e.value);
    },
    async onActionDetele(e, lineData) {
      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this record?",
        "Delete"
      );

      if (confirmDelete && e) {
        let index = undefined;

        if (lineData.data.IsCopyLine) {
          index = this.reviewDataSource.findIndex(
            (x) =>
              x.Code == lineData.data.Code &&
              x.CopyCode == lineData.data.CopyCode
          );
        } else
          index = this.reviewDataSource.findIndex(
            (x) => x.ItemCode == lineData.data.ItemCode
          );

        if (index != -1) {
          this.removeFromReview(index);
        }

        if (this.dataViewType == "product-entry") {
          let id = undefined;
          if (lineData.data.IsCopyLine) {
            id = this.productEntryLocalItems.findIndex(
              (x) =>
                x.Code == lineData.data.Code &&
                x.CopyCode == lineData.data.CopyCode
            );
          } else
            id = this.productEntryLocalItems.findIndex(
              (x) => x.ItemCode == lineData.data.ItemCode
            );
          await this.removeFromProductEntry(id);
          this.$refs["sales-order-v2"].$refs["transactionGrid"].gridRepaint();
        }
      }
    },
    async removeFromProductEntry(index) {
      if (index != -1) {
        if (this.productEntryLocalItems.length === 1) {
          this.productEntryLocalItems[0] = Object.assign(
            { IsCopyLine: false, IsNewLine: true },
            productEntryBase
          );
          // this.$refs["sales-order-v2"].$refs["transactionGrid"].setDataSource(
          //   this.productEntryLocalItems
          // );
        } else {
          this.productEntryLocalItems.splice(index, 1);
        }
      }
    },
    async setActiveAccountingPeriod() {
      let startDateResult = await StockTransferService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        this.ui.DateAdjustedMin = new Date(accountingPeriod.StartDate);
      }

      let endDateResult = await StockTransferService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0];
        this.ui.DateAdjustedMax = new Date(accountingPeriod.EndDate);
      }
    },
    productEntryPostProcess(data) {
      // this.reviewDataSource.forEach((element) => {
      //   var index = data.findIndex((x) => x.Code == element.Code);
      //   if (index == -1) data.push(element);
      //   else {
      //     var x = data.findIndex((x) => x.CopyCode == element.CopyCode);
      //     if (x == -1) data.push(element);
      //   }
      // });

      if (this.baseView.mode != "create") {
        // data.forEach((element) => {
        //   var maxID = Math.max(...data.map((e) => e.ID));
        //   element.ID = ++maxID;
        // });
      } else {
        if (data.length == 0) data.push({ ...productEntryBase });
      }

      return data;
    },
    async initialized() {
      // await this.setActiveAccountingPeriod();

      // await this.setProductDataSourceItems();
      // await this.setBranchDataSourceItems();
      if (this.baseView.mode == "create") {
        if (this.productEntryLocalItems.length == 0) {
          let dataObj = Object.assign(
            { IsCopyLine: false, IsNewLine: true },
            productEntryBase
          );
          this.productEntryLocalItems.push({ ...dataObj });
        }
        await this.$store.dispatch("screenFactors/getFactors", [
          616,
          549,
          550,
          505,
          95,
          87,
          565,
          571,
          655,
          643,
          368,
          639,
          578,
          95,
        ]);

        this.factor368ExchangeRateFieldEditable = getFactorByCode(368);

        //  Populate defaults in the Create Mode
        this.model.DateIn = new Date();
        this.model.Status = "D";
        this.model.Code = 0;

        let response = await DefaultCompanyBranchDivisionService.getDefault();

        if (response.data.value.length > 0) {
          this.model.CompanyCode = response.data.value[0].CompanyCode;
          this.defaultBranchCode = response.data.value[0].BranchCode;
          this.model.BranchCode = response.data.value[0].BranchCode;
          this.defaultDivisionCode = response.data.value[0].DivisionCode;
          this.model.DivisionCode = response.data.value[0].DivisionCode;

          await this.getSalesUMs(this.model.BranchCode);

          await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
            (res) => {
              this.model.CurrencyCode = res.data.value[0].CurrencyCode;
              this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
            }
          );

          let result = await CompanyCurrencyService.getByCurrencyCode(
            this.model.CurrencyCode
          );
          this.model.ExchangeRate = result.data.value[0].BuyRate;

          let factor549DefaultRequiredBy = getFactorByCode(549);

          if (factor549DefaultRequiredBy.Factorc == "Y") {
            let factor550RequiredByLeadDays = getFactorByCode(550);
            let requiredByLeadDays = parseInt(
              factor550RequiredByLeadDays.Factorc
            );
            let requiredByDate = new Date();
            requiredByDate.setDate(
              requiredByDate.getDate() + requiredByLeadDays
            );

            this.model.RequiredByDate = requiredByDate;

            let factor616DateForPriceGroupPriceSelection = getFactorByCode(616);
            if (factor616DateForPriceGroupPriceSelection.Factorc != "Date In") {
              this.model.FilterDate = this.model.RequiredByDate.toYYYYMMDD();
            } else {
              this.model.FilterDate = this.model.DateIn.toYYYYMMDD();
            }

            let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

            if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
              this.model.ShipDate = this.model.RequiredByDate;
            } else {
              this.model.ShipDate = new Date();
            }
          }
          await this.setDefaultSalesRep();

          let factor87DefaultSalesOrderTypeCode = getFactorByCode(87);
          this.model.SalesOrderTypeCode =
            factor87DefaultSalesOrderTypeCode.Factorc;
        }

        // END

        this.$store.dispatch("dataContext/setDataViewType", "product-entry");

        this.reload = false;
        this.loaded = true;
        this.setLoading = false;
      } else {
        if (this.baseView.mode == "review")
          this.$store.dispatch("dataContext/setDataViewType", "review");
        else
          this.$store.dispatch("dataContext/setDataViewType", "product-entry");

        await SalesOrderService.getByCode(this.baseView.id)
          .then((res) => {
            if (res.data.value[0].Customer.StopCredit == "Y")
              res.data.value[0].CustomStatus = "Credit Hold";
            else res.data.value[0].CustomStatus = undefined;

            this.model = res.data.value[0];
            this.model.CustomerDeliveryAddressLineNo = this.model.CustomerDeliveryAddressLineNo.split(
              " "
            )[0];

            this.model.CustomerName = res.data.value[0].Customer.Name;

            this.setDeliveryAddressDataSourceItems(
              this.model.CustomerCode,
              this.model.CustomerDeliveryAddressLineNo
            );
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });

        await SalesOrderNoteService.getNotesBySOCode(this.baseView.id)
          .then((res) => {
            this.model.Notes = res.data.value;
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });

        await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
          (res) => {
            this.model.CurrencyCode = res.data.value[0].CurrencyCode;
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
          }
        );

        let record = await SalesOrderV2Service.getSalesOrderDetailsByCode(
          this.baseView.id
        );
        if (record && record.data.value.length > 0) {
          var data = record.data.value;
          await data.forEach(async (element, index) => {
            // this.model.Status = element.Status;
            // element.Description1 = element.ItemDescription;
            element.ItemDescription = element.Description1;
            element.Code = element.ItemCode;
            element.ProductCode = element.ItemCode;
            element.ProductDescription = element.Description1;
            element.ID = index + 1;
            element.validCode = element.ItemCode;
            this.addToReview({ ...element });
            this.productEntryLocalItems.push({ ...element });
          });
        }

        this.reload = false;
        this.loaded = true;
        this.setLoading = false;
      }
      // this.loaded = true;
    },
    async setDefaultSalesRep() {
      var featureItems = FeatureStorage.getItems();
      if (featureItems[0].ApplicationUserTypeCode == "Sales") {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative().then(
          (res) => {
            this.defaultSalesRepCode =
              res.data.value[0].SalesRepresentativeCode;
            this.model.SalesRepresentativeCode =
              res.data.value[0].SalesRepresentativeCode;
          }
        );
      } else {
        await CustomerService.getByCode(this.baseView.id)
          .then((res) => {
            this.defaultSalesRepCode =
              res.data.value[0].SalesRepresentativeCode;
            this.model.SalesRepresentativeCode =
              res.data.value[0].SalesRepresentativeCode;
          })
          .catch((err) => {
            if (err) {
              this.defaultSalesRepCode = getFactorByCode(95).Factorc;
              this.model.SalesRepresentativeCode = getFactorByCode(95).Factorc;
            }
          });
      }
    },

    async setDeliveryAddressDataSourceItems(customerCode, lineNo) {
      logDev("customerCode", customerCode);
      let deliveryAddresDs = CustomerDeliveryAddressService.dataSourceConfig(
        "api/CustomerDeliveryAddress",
        {
          select: [
            "CompanyName",
            "PhysicalAddressStreetLine1",
            "PhysicalAddressStreetLine2",
            "PhysicalAddressSuburb",
            "PhysicalAddressState",
            "PhysicalAddressPostcode",
            "PhysicalAddressCountry",
            "RecordId",
            "LineNo",
          ],
          key: "RecordId",
          filter: [
            ["Inactive", "=", "N"],
            "and",
            ["CustomerCode", "=", customerCode],
          ],
        }
      );

      let results = await deliveryAddresDs.load();

      let defaultLineNo = 1;
      if (lineNo) defaultLineNo = lineNo;
      let deliveryAddressLine1Record = results.find(
        (x) => x.LineNo == defaultLineNo
      );

      if (deliveryAddressLine1Record) {
        deliveryAddressDataSourceItems = results;
        if (this.DeliveryAddressCompanyNameEditor()) {
          this.DeliveryAddressCompanyNameEditor().beginUpdate();
          this.DeliveryAddressCompanyNameEditor().option(
            "items",
            deliveryAddressDataSourceItems
          );
          this.DeliveryAddressCompanyNameEditor().option(
            "value",
            deliveryAddressLine1Record.CompanyName
          );
          this.DeliveryAddressCompanyNameEditor().endUpdate();
        }

        if (!lineNo) {
          this.model.DeliveryAddressCompanyName =
            deliveryAddressLine1Record.CompanyName;

          this.model.DeliveryAddressCountry =
            deliveryAddressLine1Record.PhysicalAddressCountry;
          this.model.DeliveryAddressPostcode =
            deliveryAddressLine1Record.PhysicalAddressPostcode;
          this.model.DeliveryAddressState =
            deliveryAddressLine1Record.PhysicalAddressState;
          this.model.DeliveryAddressStreetLine1 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine1;
          this.model.DeliveryAddressStreetLine2 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine2;
          this.model.DeliveryAddressSuburb =
            deliveryAddressLine1Record.PhysicalAddressSuburb;
          this.model.CustomerDeliveryAddressLineNo =
            deliveryAddressLine1Record.LineNo;
        }
      }
    },

    // async setBranchDataSourceItems() {
    //   let branchDS = BranchService.dataSourceConfig("api/Branch", {
    //     filter: [["Inactive", "=", "N"]],
    //     sort: [{ selector: "Code", asc: true }],
    //     preventPagination: true,
    //   });

    //   this.branchDataSourceItems = await branchDS.load();
    // },

    async setProductDataSourceItems() {
      this.setLoading = true;
      let productsDS = ProductService.dataSourceConfig(
        "api/ProductFilterGroupSaleItemCompanyBranch",
        {
          filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
          sort: [{ selector: "Description1", asc: true }],
          preventPagination: true,
          select: [
            "ItemCode",
            "Description1",
            "BranchCode",
            "CustomerCode",
            "Inactive",
            "ItemType",
            "SalesUM",
            "StockUM",
          ],
        }
      );

      // await ProductService.getByCodeProductFilterGroupSaleItemCompanyBranch({
      //   filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and ItemCode eq '${e.value}' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
      //   // ((ItemType eq 'S') and (IsDefault eq 'Y') and (AvailableForSale eq 'Y')) and ((CustomerCode eq '10024') and (Inactive eq 'N') and (BranchCode eq '01'))
      //   select: [
      //     "ItemCode",
      //     "Description1",
      //     "BranchCode",
      //     "CustomerCode",
      //     "Inactive",
      //     "ItemType",
      //     "SalesUM",
      //     "StockUM",
      //   ],
      // });

      this.productDataSourceItems = await productsDS.load();

      this.setLoading = false;
    },
    async getSalesUMs(branchCode) {
      this.productListItems = undefined;
      await SalesOrderV2Service.getSaleItemCompanyBranchProduct(
        branchCode
      ).then((res) => {
        this.salesUMsLocalData = res.data.value;
      });
    },
  },
  watch: {
    getValidationSummaryVisible(val) {
      if (!val && this.validationLineData == "Customer") {
        this.validationLineData = undefined;
        var headerToolBarForm = this.$refs["sales-order-v2"].$refs[
          "gc-header-form-component"
        ].$refs["gc-form-header-toolbar"].$refs["toolbar-form"].$refs[
          "gc-form-comp"
        ].instance;
        if (headerToolBarForm) {
          headerToolBarForm.getEditor("CustomerCode").focus();
          var cusDropdown = headerToolBarForm
            .getEditor("CustomerCode")
            .instance();
          cusDropdown.open();
        }
      } else if (!val && this.validationLineData) {
        this.focusOnGridCell(
          this.validationLineData.rowIndex,
          this.validationDataField
            ? this.validationDataField
            : this.validationLineData.column.dataField
        );
        this.validationLineData = undefined;
        this.validationDataField = undefined;
      }
    },
  },
};
</script>

<style lang="scss">
.sales-order-v2 {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: middle !important;
  }
}
</style>
